import { render, staticRenderFns } from "./Task-panel.vue?vue&type=template&id=3ec6e31a&scoped=true&"
import script from "./Task-panel.vue?vue&type=script&lang=js&"
export * from "./Task-panel.vue?vue&type=script&lang=js&"
import style0 from "./Task-panel.vue?vue&type=style&index=0&id=3ec6e31a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec6e31a",
  null
  
)

export default component.exports